import { ModalController } from "./modal_controller";

// Connects to data-controller="toggle-form"
export default class extends ModalController {
  static targets = ["showArea", "editArea", "input", "editButton"];

  connect() {
    super.connect();
    this.#initializeView();
  }

  // 値が変更されている場合は編集フォームで表示する
  #initializeView() {
    for (const input of this.inputTargets) {
      if (input.value !== input.dataset.defaultValue) {
        this.editButtonTarget.click();
        return;
      }
    }
  }

  showDialog() {
    super.show();
  }

  closeDialog() {
    super.close();
  }

  edit() {
    this.hideElements(this.showAreaTargets);
    this.showElements(this.editAreaTargets);
  }

  reset() {
    this.closeDialog();
    this.hideElements(this.editAreaTargets);
    this.showElements(this.showAreaTargets);
    this.inputTargets.forEach((input) => {
      input.value = input.dataset.defaultValue;
    });
  }

  showElements(elements) {
    elements.forEach((element) => {
      element.style.display = "";
    });
  }

  hideElements(elements) {
    elements.forEach((element) => {
      element.style.display = "none";
    });
  }
}
